import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-backbutton",
  "use": "icon-backbutton-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-backbutton\"><path d=\"M19.291 10.566v-1.79H1.379v1.79H19.29Z\" fill=\"#FA6400\" /><path d=\"m1.654 10.937 9.5-9.499L9.887.171l-9.5 9.5 1.267 1.266Z\" fill=\"#FA6400\" /><path d=\"m9.887 19.17 1.267-1.266-9.5-9.5L.388 9.671l9.499 9.5Z\" fill=\"#FA6400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol